import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageContext';

import Latestblogowl from '../../markup/Element/Owlblog2';
import heroBanner from '../../images/background/EMS_9287.jpg';
import banner from '../../images/background/image-2.jpg';

var bnr1 = require('../../images/banner/bnr1.jpg');
var bnr2 = require('../../images/background/bg4.jpg');

export function AboutUs() {
	const { t } = useLanguage();
	return (
		<div className="page-content bg-white">
			<div className="dez-bnr-inr overlay-black-middle" style={{ backgroundImage: "url(" + heroBanner + ")" }}>
				<div className="container">
					<div className="dez-bnr-inr-entry">
						<h1 className="text-white" style={{ fontSize: '3rem', fontWeight: 'bold', marginBottom: '20px' }}>{t('about.title')}</h1>
					</div>
				</div>
			</div>
			<div className="content-block">
				<div className="section-full content-inner overlay-white-middle">
					<div className="container">
						<div className="row align-items-center m-b50">
							<div className="col-md-12 col-lg-6 m-b20">
								<h2 className="m-b5">{t('about.title')}</h2>
								<h3 className="fw4">{t('about.subtitle')}</h3>
								<p className="m-b15">{t('about.description1')}</p>
								<p className="m-b15">{t('about.description2')}</p>
							</div>
							<div className="col-md-12 col-lg-6">
								<img style={{ maxWidth: '70%' }}  src={banner} alt="" />
							</div>
						</div>
						<div className="row">
							<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
								<div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
									<div className="icon-md text-primary m-b20"> <Link to={"#"} className="icon-cell text-primary"><i className="ti-target"></i></Link> </div>
									<div className="icon-content">
										<h5 className="dlab-tilte text-uppercase">{t('about.mission')}</h5>
										<p>{t('about.missionDesc')}</p>
									</div>
								</div>
							</div>
							<div className="col-lg-6 col-md-6 col-sm-12 m-b30">
								<div className="icon-bx-wraper p-a30 center bg-gray radius-sm">
									<div className="icon-md text-primary m-b20"> <Link to={"#"} className="icon-cell text-primary"><i className="ti-eye"></i></Link> </div>
									<div className="icon-content">
										<h5 className="dlab-tilte text-uppercase">{t('about.vision')}</h5>
										<p>{t('about.visionDesc')}</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="section-full content-inner-2 call-to-action overlay-black-dark text-white text-center bg-img-fix" style={{ backgroundImage: "url(" + banner + ")" }}>
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<h2 className="m-b10">{t('about.ctaTitle')}</h2>
								<p className="m-b0">{t('about.ctaDesc')}</p>
								<Link to={"/register"} className="site-button m-t20 outline outline-2 radius-xl">{t('about.createAccount')}</Link>
							</div>
						</div>
					</div>
				</div> */}
				{/* <div className="section-full content-inner-2 overlay-white-middle">
					<div className="container">
						<div className="section-head text-black text-center">
							<h2 className="text-uppercase m-b0">Nuestras Últimas Publicaciones</h2>
							<p>Mantente informado sobre las últimas tendencias del mercado laboral y consejos para tu desarrollo profesional.</p>
						</div>
						<Latestblogowl />
					</div>
				</div> */}
			</div>
		</div>
	)
}
